import { render } from "./ProjectInfo.vue?vue&type=template&id=3a234aed&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"

import "./ProjectInfo.vue?vue&type=style&index=0&id=3a234aed&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a234aed"]])

export default __exports__